import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import PushNotification from "../../images/pushNotification.png";
import SendEmail from "../../images/sendEmail.png"

const Marketing = () => {
  const MarketingDocs = {
    title: "Marketing Notifications",
    description: "Learn how to efficiently manage marketing notifications to engage customers.",
    sections: [
      {
        title: "Overview",
        content:
          "Marketing notifications can be delivered as pop-up messages within the app or as emails containing promotional content.",
      },
      {
        title: "Push Notification",
        content:
          "Push notifications appear when the app is opened, allowing customers to view marketing content immediately.",
        image: PushNotification,
        imageAlt: "Add Push Notification",
        imageCaption: "Figure 1: Comprehensive view of the add push notification dashboard",
        subsections: [
          {
            title: "Add Push Notification",
            content: "To add new marketing content, click on the Push Notification option.",
            steps: [
              "Title: Enter a concise and engaging title for the notification.",
              "Message: Provide a brief description of the offering.",
            ],
          },
          {
            title: "Email",
            content:
              "Use the email interface to send marketing content directly to customers.",
            image: SendEmail,
            imageAlt: "Send Product Email",
            imageCaption: "Figure 1: Comprehensive view of the send product email modal",
            steps: [
              "To: Enter the email addresses of customers. (Consult your supervisor for the appropriate email list.)",
              "Subject: Write a clear and relevant subject line for the email.",
              "Body: Compose the main content of the email, including promotional details.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...MarketingDocs} />;
};

export default Marketing;
